// src/components/GlobalLoginModal.jsx
import { useSelector, useDispatch } from "react-redux";
import { SignUpModal } from "./modals/auth/signUpModal";
import { toggleLoginModal } from "../redux/auth/authActions";

export default function GlobalLoginModal() {
  const dispatch = useDispatch();
  const showLoginModal = useSelector((state) => state.auth.showLoginModal);

  const closeModal = () => {
    dispatch(toggleLoginModal(false));
  };

  if (!showLoginModal) return null;

  return (
    <SignUpModal show={showLoginModal} onClose={closeModal} type="checkout" />
  );
}
